import type { Action } from 'redux';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { type OptimisticUiMeta, beginOptimisticUiMeta } from './optimistic-ui-meta.tsx';

export const CARD_SET_META_KEY = Symbol('CARD_SET_META_KEY');

export type CardSetMetaKey = typeof CARD_SET_META_KEY;

export type ActionWithCardSetMeta = Action & { meta: CardSetMeta & { failedBatchIds?: string[] } };
export type RetryableActionBuilder = () => ActionWithCardSetMeta;

export type CardSetMeta = {
	[CARD_SET_META_KEY]: CardSetMetaPayload;
	analyticsEvent: UIAnalyticsEvent;
} & OptimisticUiMeta;

export type CardSetMetaPayload = {
	issueKey: IssueKey;
	fieldId: string;
	newValue: unknown;
	// Allows a failed action to be retried by being able to rebuild the action
	// anywhere else in the code
	retryAction: RetryableActionBuilder;
};

export const setCardSetMeta = (
	payload: CardSetMetaPayload,
	analyticsEvent: UIAnalyticsEvent,
): CardSetMeta => ({
	[CARD_SET_META_KEY]: payload,
	analyticsEvent,
	...beginOptimisticUiMeta(),
});
